import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        userInfo: null,
        toolbarTitle: '',
        customMods: [],
        mode: null,
    },
    mutations: {
        update(state, payload) {
            const next = Object.assign({}, payload);
            for (const key in state) {
                if (state.hasOwnProperty(key) && next.hasOwnProperty(key)) {
                    state[key] = next[key];
                }
            }
        },
    },
    actions: {
        update(store, payload) {
            store.commit('update', Object.assign({}, payload));
        },
    },
});

export default store;
